export default {
  OPERATION_PAYMENT: 'payment',
  OPERATION_TOKENIZE: 'tokenize',
  OPERATION_PAYMENT_TOKENIZE: 'pay_and_tokenize',
  WARRANTY_SAVED: 'saved',
  WARRANTY_NOT_SAVED: 'not_saved',
  PAYMENT_PAID: 'paid',
  PAYMENT_NOT_PAID: 'not_paid',
};
